import { createTheme } from '@aws-amplify/ui-react';

export const navyTheme = createTheme({
    name: 'navy-theme',

    tokens: {
        colors: {
            brand: {
                primary: {
                    10: { value: '#e6ecf5' },
                    20: { value: '#c0d0e7' },
                    40: { value: '#7295cb' },
                    60: { value: '#2e5ea8' },
                    80: { value: '#0f2b5c' },
                    90: { value: '#0a1d40' },
                    100: { value: '#050f24' },
                },
            },

            info: {
                10: { value: '#e6ecf5' },
                20: { value: '#c0d0e7' },
                60: { value: '#2e5ea8' },
                80: { value: '#0f2b5c' },
                90: { value: '#0a1d40' },
            },

            background: {
                primary: { value: '#f4f7fb' },
                secondary: { value: '#e6ecf5' },
            },

            font: {
                primary: { value: '#0a1d40' },
                interactive: { value: '#0f2b5c' },
            },

            border: {
                primary: { value: '#c0d0e7' },
                focus: { value: '#0f2b5c' },
            },
        },

        components: {
            button: {
                primary: {
                    backgroundColor: {
                        value: '{colors.brand.primary.80}',
                    },

                    _hover: {
                        backgroundColor: {
                            value: '{colors.brand.primary.90}',
                        },
                    },

                    _focus: {
                        backgroundColor: {
                            value: '{colors.brand.primary.90}',
                        },

                        borderColor: {
                            value: '{colors.brand.primary.100}',
                        },
                    },

                    _active: {
                        backgroundColor: {
                            value: '{colors.brand.primary.100}',
                        },
                    },
                },
            },

            liveness: {
                cameraModule: {
                    borderWidth: { value: '0' },
                    borderColor: {
                        value: '{colors.brand.primary.80}',
                    },
                },
            },
        },
    },
});
